/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { t } from 'utils/translates';
import {
  changeFieldLinks,
  clearLinkErrorByKey
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import {
  selectAllErrors,
  selectFieldLinks,
  selectLinkErrorByKey
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import _ from 'lodash';

class TasksLinksInputBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      links: props.fieldLinks.value
    };
    this.inputsRefs = {
      [props.fieldLinks.field]: React.createRef()
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevState.links, this.state.links)) {
      this.props.changeFieldLinks(this.state.links);
    }

    if (_.isEmpty(prevProps.allErrors) && !_.isEmpty(this.props.allErrors)) {
      const firstErrorField = Object.keys(this.props.allErrors)[0];
      if (firstErrorField.includes(this.props.fieldLinks.field)) {
        this.inputsRefs[this.props.fieldLinks.field].current.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }

  render() {
    const hasError = linkKey => this.props.linkErrorByKey(linkKey);
    const errorDesc = linkKey => {
      if (this.props.linkErrorByKey(linkKey)) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {this.props.linkErrorByKey(linkKey)[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <React.Fragment>
        <label
          ref={this.inputsRefs[this.props.fieldLinks.field]}
          className="control-label"
          htmlFor={'link1'}
        >
          {t('Ссылки')}
        </label>
        {this.state.links.map((value, key) => {
          const num = key + 1;
          return (
            <div
              key={`taskLink-${key + 1}`}
              className={`form-group ${hasError(key) ? 'has-error' : ''}`}
            >
              <div className="input-group">
                <span className="input-group-addon">{num}</span>
                <input
                  className="form-control"
                  placeholder="https://"
                  type="text"
                  id="link2"
                  value={value}
                  onChange={e => {
                    if (hasError(key)) {
                      this.props.clearLinkErrorByKey(key);
                    }
                    const links = [...this.state.links];
                    links[key] = e.target.value;
                    this.setState({
                      links
                    });
                  }}
                />
                {key > 0 ? (
                  <span className="input-group-btn">
                    <button
                      className="btn btn-default"
                      data-placement="top"
                      data-toggle="tooltip"
                      title=""
                      type="button"
                      id="deleteLink2"
                      data-original-title={t('Удалить')}
                      onClick={() =>
                        this.setState({
                          links: this.state.links.filter(
                            (v, k) => k !== parseInt(key, 10)
                          )
                        })
                      }
                    >
                      <i className="fa fa-trash" />
                    </button>
                  </span>
                ) : null}
              </div>
              {errorDesc(key)}
            </div>
          );
        })}
        <div className="form-group">
          <button
            className="btn btn-default"
            type="button"
            onClick={() => {
              this.setState({
                links: [...this.state.links, '']
              });
            }}
          >
            <i className="fa fa-plus" /> {t('Добавить ссылку')}
          </button>
          <small className="help-block">
            {t(
              'Ссылка для перехода, если указать несколько, то они по очереди будут выдаваться разным исполнителям.'
            )}
          </small>
        </div>
      </React.Fragment>
    );
  }
}

TasksLinksInputBlock.propTypes = {
  fieldLinks: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  linkErrorByKey: PropTypes.func.isRequired,
  allErrors: PropTypes.shape({}).isRequired,
  changeFieldLinks: PropTypes.func.isRequired,
  clearLinkErrorByKey: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  fieldLinks: selectFieldLinks(state, props.reducerName),
  allErrors: selectAllErrors(state, props.reducerName),
  linkErrorByKey: key => selectLinkErrorByKey(state, props.reducerName, key)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldLinks: value =>
    dispatch(changeFieldLinks(props.reducerName, value)),
  clearLinkErrorByKey: key =>
    dispatch(clearLinkErrorByKey(props.reducerName, key))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TasksLinksInputBlock);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/DescTaskInputs/TasksLinksInputBlock/TasksLinksInputBlock.js